import React from 'react';
import styled from 'styled-components';


const EsReqDoneTrProdDescBlock = styled.tr``;

const EsReqDoneTrProdDesc = (curitem, index) => {

    let prdctdesc = curitem.es_detail_prdct_desc;

    // 
    if (curitem.es_detail_prdct_desc !== null && curitem.es_detail_prdct_desc.length > 27) {
        prdctdesc = curitem.es_detail_prdct_desc.substr(0, 27);
    }
    return (
        <EsReqDoneTrProdDescBlock key={index}>
            <td colSpan="5" className="gray border_t-none thumb_none padding_none">
                {prdctdesc}
            </td>
        </EsReqDoneTrProdDescBlock>
    );
};

export default EsReqDoneTrProdDesc;